export default __webpack_public_path__ + "static/media/order_search.dd2f6095.svg";